import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import urls from "./config/urls.json";
import logo from "./assets/imgs/logo.svg";
import { LuogoPage } from "./pages/LuogoPage/LuogoPage";
import { FilialiPage } from "./pages/FilialiPage/FilialiPage";
import { DatiPersonaliNonRiconosciutoPage } from "./pages/DatiPersonaliNonRiconosciutoPage/DatiPersonaliNonRiconosciutoPage";
import { RiepilogoPage } from "./pages/RiepilogoPage/RiepilogoPage";
import { useEffect, useState } from "react";
import { useSession } from "./hooks/useSession";
import { useStates } from "./hooks/useStates";
import { t, randString } from "./services/formatters";
import { useSessionTracker, useGlobalErrorTracker } from "./lib/otel";
import "./assets/styles/App.css";

const ProtectedRoute = ({ children, canNavigateIf }) => {
    return canNavigateIf() ? children : <Navigate replace={true} to={urls.luogo.path} />;
};

const App = () => {
    const { read, update } = useSession();
    const { isFilialiPageReady, isCfPageReady, isDatiUtenteReady, isRiepilogoPageReady } = useStates();
    const location = useLocation();

    // OTel: avvia lo span radice di sessione e logga il landing all'atterraggio
    const { trackLandingEvent } = useSessionTracker();
    useEffect(() => {
        trackLandingEvent();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // OTel: intercetta errori JS ed eccezioni Promise non gestite a livello globale
    useGlobalErrorTracker();

    // 1. handle footer variables
    // prettier-ignore
    const [tassiFooter, setTassiFooter] = useState({USR_FA_PP_COMUNICAZIONI_TRASPARENZA_ANNUALI: "", USR_FA_PP_COMUNICAZIONI_TRASPARENZA_PERIODICHE: "",USR_FA_PP_DURATA_TOTALE_FINANZIAMENTO: "",USR_FA_PP_GESTIONE_PRATICA: "",USR_FA_PP_IMPORTO_TOTALE_CREDITO: "",USR_FA_PP_IMPORTO_TOTALE_DOVUTO: "",USR_FA_PP_ISTRUTTORIA: "",USR_FA_PP_MASSIMO_RICHIEDIBILE: "",USR_FA_PP_MINIMO_RICHIEDIBILE: "",USR_FA_PP_ONERI_FISCALI: "",USR_FA_PP_RIMBORSABILE_MASSIMO: "",USR_FA_PP_RIMBORSABILE_MINIMO: "",USR_FA_PP_TAEG: "",USR_FA_PP_TAEG_MASSIMO: "",USR_FA_PP_TAEG_MASSIMO_FIL: "",USR_FA_PP_TAEG_MINIMO_FIL: "",USR_FA_PP_TAN: "",USR_FA_PP_TAN_MASSIMO: "",USR_FA_PP_TAN_MASSIMO_FIL: "",USR_FA_PP_TAN_MINIMO_FIL: "",USR_GEN_VALIDITA: ""});
    let tassiTimeout = null;
    useEffect(() => {
        window.res3 = randString(20);

        tassiTimeout = setInterval(() => {
            if (window && undefined != window.USR_GEN_VALIDITA) {
                clearInterval(tassiTimeout);
                tassiTimeout = null;
                setTassiFooter({ ...window });
            }
        }, 100);
    }, []);

    // 2. stepbar and scroll to top for every page change
    useEffect(() => {
        updateStepBar();

        setTimeout(() => {
            window.scrollTo(0, 0);
        }, 0);
    }, [location.pathname]);

    const updateStepBar = () => {
        try {
            update(
                "progress",
                urls[
                    Object.keys(urls).filter((_) => {
                        return urls[_].path == location.pathname;
                    })[0]
                ].progress
            );
        } catch (error) {
            update("progress", 0);
        }
    };

    useEffect(() => {
        window.dataLayer.push({
            funnelVersion: "nuovo",
        });
    }, []);

    return (
        <>
            <div id="layout-container">
                <header id="layout-header">
                    <img
                        onClick={() => {
                            window.open("https://www.mps.it/", "_blank");
                        }}
                        className={"logo clickable standardLogo"}
                        src={logo}
                        alt="Compass"
                    />
                    <>
                        <div className="step-bar step-bar-component" style={{ width: `${read("progress")}%` }}></div>
                        <div className="step-bar-background" style={{ width: `${100 - read("progress")}%` }}></div>
                    </>
                </header>

                <main className="section" id="layout-content">
                    <Routes>
                        <Route
                            path={urls.luogo.path}
                            element={
                                <ProtectedRoute
                                    canNavigateIf={() => {
                                        return true;
                                    }}>
                                    <LuogoPage />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path={urls.filiali.path}
                            element={
                                <ProtectedRoute
                                    canNavigateIf={() => {
                                        return isFilialiPageReady();
                                    }}>
                                    <FilialiPage />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path={urls.datiPersonaliNonRiconosciuto.path}
                            element={
                                <ProtectedRoute
                                    canNavigateIf={() => {
                                        return isDatiUtenteReady();
                                    }}>
                                    <DatiPersonaliNonRiconosciutoPage />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path={urls.riepilogo.path}
                            element={
                                <ProtectedRoute
                                    canNavigateIf={() => {
                                        return isRiepilogoPageReady();
                                    }}>
                                    <RiepilogoPage />
                                </ProtectedRoute>
                            }
                        />
                        {/* Not found - back to Home page */}
                        <Route
                            path="*"
                            element={
                                <ProtectedRoute
                                    canNavigateIf={() => {
                                        return false;
                                    }}></ProtectedRoute>
                            }
                        />
                    </Routes>
                </main>

                <footer className="section" id="layout-footer">
                    <h6 className="text-uppercase text-center" aria-label={t("informazioni_generali")}>
                        {t("informazioni_generali")}
                    </h6>

                    {read("prodotto") == "minicredito" ? (
                        <div className="text-xs" aria-label={t("info_compass")}>
                            CONDIZIONI ECONOMICHE APPLICATE - Importo totale del credito (Fido) 1.500€ ; TAN fisso (Tasso Annuo Nominale) 18% : TAEG (Tasso Annuo Effettivo Globale) 20,15%; Sono
                            compresi nel TAEG: Interessi calcolati al TAN indicato 18%; Spese emissione 0€; Quota associativa annuale 0€; Spese di incasso 0€; Spese di invio estratto conto annuale
                            (cartaceo) 0€; Spese di invio comunicazione periodica di trasparenza annuale 0€; Oneri fiscali applicati al contratto 3,75€* ( *importo calcolato su fido pari a 1.500€);
                            Rata mensile(variabile in base al saldo): con saldo fino a 1.600€ la rata è pari a 50€; con saldo tra 1.600,01€ e 2.500€ la rata è pari a 100€. Il numero delle e l'importo
                            totale dovuto vengono determinati in funzione degli utilizzi del fido, accordato sulla base del merito creditizio del cliente valutato da Compass Banca S.p.A..
                            <br />
                            <br />
                            ESEMPIO RAPPRESENTATIVO DI UTILIZZO DI MPS MINICREDITO ON - Importo utilizzato 500€; Importo totale dovuto a conclusione del piano di rimborso 551,10€ ; Numero rate mensili
                            12 così composte: 11 rate da 50€ e 1 rata a conclusione del piano di 1,10€. Il contratto ha una durata di 60 mesi con rinnovo tacito. Il cliente ha facoltà di recedere dal
                            rapporto in ogni momento senza spese e senza penalità. Il Cliente può chiedere a Compass di rimborsare il debito residuo in un'unica soluzione, senza alcun costo
                            aggiuntivo.
                            <br />
                            <br />
                            Messaggio pubblicitario con finalità promozionale. Per le condizioni economiche e contrattuali è necessario fare riferimento ai documenti informativi e in particolare ai Moduli Informazioni Europee di Base sul Credito ai Consumatori disponibili in tutte le filiali di Banca Monte dei Paschi di Siena che opera in qualità di intermediario del credito convenzionato in esclusiva con Compass Banca S.p.A.. Salvo approvazione della richiesta di linea di fido da parte di Compass Banca S.p.A.
                        </div>
                    ) : read("prodotto") == "cqs" ? (
                        <div className="text-xs" aria-label={t("info_compass")}>
                            <b>Messaggio pubblicitario con finalità promozionale</b>. Per le condizioni economiche e contrattuali si rimanda ai documenti informativi disponibili presso gli agenti in attività finanziaria di Compass Banca S.p.A., che operano in qualità di intermediari del credito monomandatari con esclusiva di prodotto di Compass Banca S.p.A., i quali potranno offrire i servizi finanziari di Compass Banca S.p.A. ai potenziali clienti appositamente individuati dalla Banca Monte dei Paschi di Siena S.p.A., per effetto di uno specifico accordo, con vincolo di esclusiva, tra quest’ultima e Compass Banca S.p.A.. Salvo approvazione della richiesta di finanziamento da parte di Compass Banca S.p.A..                            
                            <br /><br />
                            Esempio rappresentativo relativo ad un prestito rimborsabile mediante cessione del quinto dello stipendio richiesto da un pensionato di 66 anni: importo totale del credito € 18.296,24. Importo totale dovuto € 27.600,00. Durata del contratto: 120 mesi. Importo rata € 230. TAEG 9,19%, inclusivo di: interessi al Tan Fisso 8,80%; e oneri fiscali applicati al contratto €16,00. Offerta valida fino al 30/09/2026.
                            <br /><br />
                            Esempio rappresentativo relativo ad un prestito rimborsabile mediante cessione del quinto dello stipendio richiesto da un pensionato di 75 anni: importo totale del credito € 15.323,68. Importo totale dovuto € 27.600,00. Durata del contratto: 120 mesi. Importo rata € 230. TAEG 13,95%, inclusivo di: interessi al Tan Fisso 13,11%, e oneri fiscali applicati al contratto €16,00. Offerta valida fino al 30/09/2026.
                            <br /><br />
                            Esempio rappresentativo relativo ad un prestito rimborsabile mediante cessione del quinto dello stipendio richiesto da un dipendente privato con 48 anni di età e 8 anni di anzianità di servizio: importo totale del credito € 14.475,89. Importo totale dovuto € 24.000,00. Durata del contratto: 120 mesi. Importo rata € 200. TAEG 11,65%, inclusivo di: interessi al Tan Fisso 11,05%; e oneri fiscali applicati al contratto €16,00. Offerta valida fino al 30/09/2026.                            
                            <br /><br />
                            Esempio rappresentativo relativo ad un prestito rimborsabile mediante cessione del quinto dello stipendio richiesto da un dipendente privato con 52 anni di età e 16 anni di anzianità di servizio: importo totale del credito € 25.666,53. Importo totale dovuto € 36.000,00. Durata del contratto: 120 mesi. Importo rata € 300. TAEG 7,39%, inclusivo di: interessi al Tan Fisso 7,14%; e oneri fiscali applicati al contratto €16,00. Offerta valida fino al 30/09/2026.
                            <br /><br />
                            L'elenco delle Filiali è disponibile sul sito <a target="_blank" href="http://www.mps.it/">www.mps.it</a> . Documenti informativi disponibili presso le Filiali della Banca Monte dei paschi di Siena che opera in qualità di intermediario del credito convenzionato in esclusiva con Compass Banca S.p.A. L'elenco delle Filiali è disponibile sul sito <a target="_blank" href="http://www.mps.it/">www.mps.it</a> .
                            </div>
                    ) : (
                        <div className="text-xs" aria-label={t("info_compass")}>
                            <b>Messaggio pubblicitario con finalità promozionale</b>. Servizio finanziario e salvo approvazione di Banca Monte dei Paschi di Siena o Compass Banca S.p.A. della
                            richiesta di finanziamento. Per i prestiti erogati da Compass Banca S.p.A., Banca Monte dei Paschi di Siena opera in qualità di intermediario del credito convenzionato in
                            esclusiva con Compass Banca S.p.A.. Per le condizioni economiche e contrattuali è necessario fare riferimento ai documenti informativi e in particolare ai Moduli
                            Informazioni Europee di Base sul Credito ai Consumatori disponibili in tutte le filiali di Banca Monte dei Paschi di Siena. I prestiti personali possono essere erogati da
                            Banca Monte dei Paschi di Siena e da Compass Banca S.p.A., a seconda del profilo del cliente e del relativo merito creditizio. Il prestito erogato da Banca Monte dei Paschi
                            di Siena è riservato a clienti possessori dei servizi di "Firma Elettronica Avanzata e Dematerializzazione Documenti" o di "Firma Digitale Remota".
                            <br />
                            <br />
                            Esempio rappresentativo (tabella Compass): Importo totale del credito € 16.500 Importo totale dovuto € 22.588,56. Modalità di rimborso con addebito diretto in conto (SDD).
                            TAEG 11,54% inclusivo di: interessi al TAN Fisso 10,07%; spese di istruttoria finanziate pari a € 300,00; commissioni di incasso e gestione pratica € 1,50 a rata; oneri
                            fiscali applicati al contratto richiesti con prima rata € 16,00; oneri fiscali applicati alle comunicazioni periodiche di trasparenza € 2,00; spese di invio comunicazione
                            periodica di trasparenza annuale € 0,56 se cartacea (gratuita online). Durata totale del finanziamento: 72 mesi. Salvo approvazione di Compass Banca S.p.A. Documenti
                            informativi disponibili presso le Filiali della Banca Monte dei paschi di Siena che opera in qualità di intermediario del credito convenzionato in esclusiva con Compass
                            Banca S.p.A. L'elenco delle Filiali è disponibile sul sito{" "}
                            <a target="_blank" href="http://www.mps.it/">
                                www.mps.it
                            </a>{" "}
                            .
                            <br />
                            <br />
                            Esempio rappresentativo (tabella MPS): Importo totale del credito € 16.800,00. Importo totale dovuto € 22.408,56. Modalità di rimborso con addebito diretto in conto (SDD).
                            TAEG 11,46% inclusivo di: interessi al TAN Fisso 9,99%; spese di istruttoria pari a € 300,00; spese incasso e gestione pratica € 1,50 a rata; oneri fiscali applicati al
                            contratto richiesti con prima rata €16,00; oneri fiscali applicati alle comunicazioni periodiche di trasparenza € 2,00; spese di invio comunicazione periodica di
                            trasparenza annuale € 0,56 se cartacea (gratuita online). Durata totale del finanziamento: 72 mesi. Documenti informativi disponibili sul sito{" "}
                            <a target="_blank" href="http://www.mps.it/">
                                www.MPS.it
                            </a>{" "}
                            nella sezione trasparenza. L'elenco delle Filiali è disponibile sul sito{" "}
                            <a target="_blank" href="http://www.mps.it/">
                                www.MPS.it
                            </a>
                            .
                            
                        </div>
                    )}

                        
                        
                        <div className="text-xs" aria-label={t("info_compass")}>
                            <br />
                        Questo sito è protetto da reCAPTCHA e si applicano la Privacy Policy e i Termini di servizio di Google.
                        <br />
                        <br />
                        </div>
                        
                        <ul class="footer-links">
                            <li>
                                <a target="_blank" href={read("prodotto") == "minicredito" ? "https://www.compass.it/share/pdfsni/COM540.PDF" : "https://www.compass.it/share/pdfsni/INFORMATIVA-CONGIUNTA-COMPASS-BANCA-MPS.PDF"}>
                                    Privacy
                                </a>
                            </li>
                            <li
                                className="clickable"
                                onClick={() => {
                                    if (typeof window["OneTrust"] !== "undefined") {
                                        window["OneTrust"].ToggleInfoDisplay();
                                    }
                                }}>
                                <a>gestione preferenze cookie</a>
                            </li>
                            <li>
                                <a target="_blank" href="https://compass.it/cookies.html">
                                    Cookie
                                </a>
                            </li>
                        </ul>
                </footer>
            </div>
        </>
    );
};

export default App;
